import Request from '@utils/request'

export default async function auth({ next, store }) {
  const loggedInStatus = await store.getters['auth/loggedInStatus']

  if (loggedInStatus) {
    Request.setCatchError(401, true)

    return next()
  } else {
    return next({
      name: 'auth.login'
    })
  }
}
